import React from "react";
import { Switch, SwitchProps } from "@mui/material";
import styled from "@emotion/styled";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "inline-flex",

  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    color: "black",

    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        border: "none",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    border: "1px solid black",
    opacity: 1,
    backgroundColor: "#fff",
    boxSizing: "border-box",
  },
}));

interface ToggleProps extends SwitchProps {
  name: string;
  sx?: any;
}

const Toggle: React.FC<ToggleProps> = ({
  disabled,
  checked,
  onChange,
  name,
  sx = {},
}) => {
  return (
    <AntSwitch
      size="small"
      checked={checked}
      onChange={onChange}
      name={name}
      sx={{ ...sx }}
    />
  );
};

export default Toggle;
